export default {
    title: "Quotes",
    subtitle: "Manage quote requests received via email",
    settingsButton: "Settings",

    list: {
        loading: "Loading quotes...",
        noQuotes: "No quotes found",
        searchPlaceholder: "Search quotes...",
        lastUpdate: "Last update",
        viewAll: "View All Quotes",
        filters: {
            allStatuses: "All Statuses",
        },
        headers: {
            from: "From",
            subject: "Subject",
            receivedAt: "Received",
            status: "Status",
        },
    },

    status: {
        pending: "Pending",
        autoResponded: "Auto Responded",
        requiresReview: "Requires Review",
        responded: "Responded",
        archived: "Archived",
        completed: "Completed",
        cancelled: "Cancelled",
    },

    shipperStatus: {
        accepted: "Accepted by Shipper",
        rejected: "Rejected by Shipper",
        modificationRequested: "Modification Requested by Shipper",
    },

    badges: {
        autoResponded: "Auto-responded",
        requiresReview: "Requires Review",
    },

    extracted: {
        product: "Product",
        origin: "Origin",
        destination: "Destination",
        quantity: "Quantity",
        unit: "Unit",
        pickupDate: "Pickup Date",
        deliveryDate: "Delivery Date",
        estimatedValue: "Estimated Value",
        equipmentType: "Equipment Type",
        temperatureRequirements: "Temperature Requirements",
        specialRequirements: "Special Requirements",
        customsRequirements: "Customs Requirements",
    },

     detail: {
     tabs: {
     email: "Original Email",
     extractedData: "Extracted Data",
     responseEmail: "Response Email",
     createResponse: "Create Response",
     thread: "Thread",
     },
         email: {
             from: "From",
             receivedAt: "Received At",
             respondedAt: "Responded At",
             body: "Email Body",
         },
         responseEmail: {
             subject: "Subject",
             sentAt: "Sent At",
             body: "Email Body",
         },
         createResponse: {
         title: "Create Response Email",
             subject: "Subject",
             subjectPlaceholder: "E.g. Quote for {{product}} transport",
             body: "Email Body",
             bodyPlaceholder: "Enter your response email...",
         bodyHint: "Use {{variable}} to insert dynamic data. You can reference extracted data on the right.",
         extractedDataReference: "Extracted Data Reference",
         saveDraft: "Save Draft",
         send: "Send Response",
         sending: "Sending...",
         titleCounterProposal: "Create Counter-proposal",
         successTitle: "Quote sent successfully",
         successMessage: "The quote has been sent successfully to the Shipper. They will receive a notification and can view your proposal in the Quotes section.",
         price: "Price",
         pricePlaceholder: "0.00",
         validity: "Validity (days)",
         validityPlaceholder: "30",
         terms: "Terms and Conditions",
         termsPlaceholder: "Quote valid for 30 days. Advance payment required.",
         },
        extractedData: {
            title: "Extracted Structured Data",
        },
        thread: {
            freightForwarderLabel: "Freight Forwarder",
            shipperLabel: "Shipper",
            carrierLabel: "Carrier",
            bookingEmailBody: "A booking request email to the carrier has been generated based on this quote.",
            bookingCta: "The shipper has accepted the quote. You can now request booking from the carrier.",
            bookingRequested: "Booking requested",
            bookingRequestAction: "Request booking from carrier",
            requestingBooking: "Requesting...",
            requestingBookingMessage: "Requesting booking number from carrier...",
            bookingNumberReceived: "Booking number received",
            bookingNumber: "Booking Number",
            simulateBookingNumber: "Simulate",
            sharingBookingNumber: "Sharing...",
            shareBookingNumber: "Share booking number with Shipper",
            bookingShareSuccessTitle: "Booking number shared successfully",
            bookingShareSuccessMessage: "The booking number has been successfully shared with the Shipper. They will receive a notification and can view the booking number in the Quotes section.",
        },
    },
    processing: {
        currentStep: "Processing",
        steps: {
            analyzing: "Analyzing email text",
            identifying: "Identifying product",
            extracting: "Extracting structured data",
            calculating: "Calculating costs",
            applying: "Applying rules",
            generating: "Generating response",
        },
    },
    
    dashboard: {
        title: "Dashboard",
        subtitle: "Overview of your quotes and statistics",
        stats: {
            total: "Total Quotes",
            pending: "Pending",
            autoResponded: "Auto-responded",
            requiresReview: "Requires Review",
            responded: "Responded",
            archived: "Archived",
        },
        autoResponded: "Auto-responded",
        manual: "Manual",
        charts: {
            statusDistribution: "Status Distribution",
            autoVsManual: "Auto-responded vs Manual",
        },
        recentQuotes: {
            title: "Recent Quotes",
            description: "Latest quote requests received",
            viewAll: "View All",
        },
        noQuotes: "No quotes available",
    },
    settings: {
        title: "Quotes Settings",
        subtitle: "Configure rules, pricing and email templates for automatic quote management",
        tabs: {
            rules: "Rules",
            pricing: "Pricing",
            templates: "Email Templates",
        },

        rules: {
            title: "Classification Rules",
            description: "Define natural language rules to identify and classify quote requests",
            create: "Create Rule",
            edit: "Edit Rule",
            deleteConfirm: "Are you sure you want to delete this rule?",
            active: "Active",
            inactive: "Inactive",
            noRules: "No rules configured",
            naturalLanguageRule: "Natural Language Rule",
            autoResponseConditions: "Auto Response Conditions",
            form: {
                name: "Rule Name",
                namePlaceholder: "E.g. Avocado Rule",
                description: "Description",
                descriptionPlaceholder: "Optional rule description",
                naturalLanguageRule: "Natural Language Rule",
                naturalLanguageRulePlaceholder: "E.g. Identify requests for avocado transport...",
                naturalLanguageRuleHint: "Describe in natural language how to identify this type of request",
                autoResponseConditions: "Auto Response Conditions",
                addCondition: "Add Condition",
                conditionPlaceholder: "E.g. if requested product is avocado",
                isActive: "Rule active",
                isActiveLabel: "Enable this rule to activate automatic classification of requests",
            },
        },

        pricing: {
            title: "Pricing Settings",
            description: "Configure buy rate, margin and sell rate components for quote calculation",
            create: "Create Setting",
            edit: "Edit Setting",
            deleteConfirm: "Are you sure you want to delete this setting?",
            noSettings: "No settings configured",
            default: "Default Setting",
            buyRate: "Buy Rate",
            margin: "Margin",
            components: "Components",
            componentsCount: "components",
            sellRateComponents: "Sell Rate Components",
            marginType: {
                percentage: "Percentage",
                currency: "Currency",
            },
            form: {
                buyRate: "Buy Rate",
                baseCurrency: "Base Currency",
                marginValue: "Margin Value",
                marginType: "Margin Type",
                sellRateComponents: "Sell Rate Components",
                addComponent: "Add Component",
                component: "Component",
                componentName: "Component Name",
                componentNamePlaceholder: "E.g. Fuel Cost",
                componentValue: "Value",
                componentType: "Type",
                componentDescription: "Description",
                componentDescriptionPlaceholder: "Optional description",
                noComponents: "No components added",
            },
        },

        templates: {
            title: "Email Templates",
            description: "Create and edit email templates for automatic quote responses",
            create: "Create Template",
            edit: "Edit Template",
            deleteConfirm: "Are you sure you want to delete this template?",
            noTemplates: "No templates configured",
            subject: "Subject",
            body: "Body",
            draftingInstructions: "Drafting Instructions",
            form: {
                name: "Template Name",
                namePlaceholder: "E.g. Avocado Template",
                subject: "Email Subject",
                subjectPlaceholder: "E.g. Quote for {{product}} transport",
                subjectHint: "Use {{variable}} to insert dynamic data",
                body: "Email Body",
                bodyPlaceholder: "Enter email body...",
                bodyHint: "Use {{variable}} to insert dynamic data. E.g. {{recipientName}}, {{totalPrice}}",
                draftingInstructions: "Drafting Instructions",
                addInstruction: "Add Instruction",
                instructionPlaceholder: "E.g. call recipient by name",
                noInstructions: "No instructions added",
                editTab: "Edit",
                previewTab: "Preview",
                noPreview: "Preview not available",
            },
        },
    },
    
    shipper: {
        list: {
            loading: "Loading requests...",
            noRequests: "No requests found",
            searchPlaceholder: "Search requests...",
            createNew: "Create New Request",
            title: "Sent Quote Requests",
            description: "List of quote requests sent to freight forwarders",
            edit: "Edit",
            view: "View",
            cancel: "Cancel",
            confirmCancelMessage: "Are you sure you want to cancel this request?",
            confirm: "Confirm",
            filters: {
                allStatuses: "All Statuses",
            },
            headers: {
                subject: "Subject",
                sentAt: "Sent At",
                recipients: "Recipients",
                responses: "Received Quotes",
                status: "Status",
                actions: "Actions",
            },
            recipientsCount: "recipients",
            responsesCount: "quotes",
        },
        status: {
            pending: "Pending",
            responded: "Responded",
            completed: "Completed",
            cancelled: "Cancelled",
        },
        form: {
            createTitle: "Create New Request",
            editTitle: "Edit Request",
            subject: "Subject",
            subjectPlaceholder: "E.g. Quote request for transport...",
            body: "Email Body",
            bodyPlaceholder: "Enter the quote request text...",
            recipients: "Recipients (Freight Forwarder)",
            recipientsPlaceholder: "Select freight forwarders...",
            extractedDataTitle: "Request Data",
            send: "Send Request",
            update: "Update",
        },
        detail: {
            loading: "Loading...",
            notFound: "Request not found",
            back: "Back",
            sentAt: "Sent At",
            edit: "Edit",
            cancel: "Cancel",
            confirmCancelMessage: "Are you sure you want to cancel this request?",
            confirm: "Confirm",
            requestDetails: "Request Details",
            subject: "Subject",
            body: "Email Body",
            recipientsTitle: "Recipients",
            extractedData: "Request Data",
            receivedQuotes: "Received Quotes",
            tabs: {
                details: "Request Details",
                responses: "Received Quotes",
            },
            confirmCancel: {
                title: "Confirm Cancellation",
                message: "Are you sure you want to cancel this quote request?",
                confirm: "Confirm",
            },
            checkingQuotes: "Checking for new quotes...",
            newQuotesAvailable: "New quotes available!",
            newQuoteReceived: "You have received a new quote response",
            viewNewQuote: "View new quote",
            readyToComplete: "You can complete this request",
            readyToCompleteDescription: "There are one or more accepted quotes. You can mark the request as completed and simulate container creation based on these quotes.",
            waitingForBookingNumber: "Waiting for booking number",
            waitingForBookingNumberDescription: "You must wait for at least one Freight Forwarder to share the booking number before you can complete the request.",
            completeRequest: "Complete request",
            completeRequestTitle: "Complete quote request",
            completeRequestMessage: "The request will be marked as completed. The system will simulate the creation of one or more containers based on the accepted quotes.",
            completeRequestConfirm: "Confirm completion",
            creatingContainer: "Creating container...",
            creatingContainerMessage: "We are creating the container based on the accepted quotes. Please wait...",
            recipients: {
                pending: "Pending",
                respondedAccepted: "Accepted",
                respondedRejected: "Rejected",
                respondedModified: "Modification requested",
                respondedAt: "Responded at",
                sendReminder: "Send reminder",
                sendReminderTitle: "Send reminder",
                sendReminderMessage: "Do you want to send a reminder to {{name}} ({{email}})?",
                sendingReminder: "Sending...",
                confirmSendReminder: "Send reminder",
            },
        },
        responses: {
            noResponses: "No quotes received yet",
            selected: "Selected",
            receivedAt: "Received At",
            price: "Price",
            validity: "Validity",
            days: "days",
            viewDetails: "Details",
            complete: "Mark as Completed",
            detailsTitle: "Quote Details",
            from: "From",
            subject: "Subject",
            body: "Email Body",
            terms: "Terms and Conditions",
            accept: "Accept",
            reject: "Reject",
            requestModification: "Request Modification",
            accepted: "Accepted",
            rejected: "Rejected",
            modificationRequested: "Modification Requested",
            actions: "Actions",
            confirmAcceptTitle: "Confirm quote acceptance",
            confirmAcceptMessage: "Are you sure you want to accept this quote? You can still accept other quotes for different routes of the same shipment.",
            confirmAcceptConfirm: "Confirm acceptance",
            modificationEditorTitle: "Modification request",
            modificationSubject: "Subject",
            modificationBody: "Modification request text",
            modificationBodyPlaceholder: "Describe the requested modifications (e.g., price, conditions, timing)...",
            modificationSend: "Send modification request",
            modificationSubjectDefault: "Modification request",
            thread: "Message Thread",
            originalQuote: "Original Quote",
            you: "You",
            counterProposal: "Counter Proposal",
            bookingNumber: "Booking Number",
            bookingNumberRequested: "Request in progress...",
            bookingNumberShared: "The Freight Forwarder has shared the booking number for this accepted quote.",
            bookingNumberPending: "The Freight Forwarder is requesting the booking number from the carrier. You will receive a notification when it is available.",
            received: "Received",
            tabs: {
                thread: "Thread",
                extractedData: "Extracted Data",
            },
        },
    },
};
